// Minimal official-style brand marks. Rendered as inline SVG so we can style
// stroke color via `currentColor` while keeping shapes clean/premium.
export function IconX({ size = 14 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
        >
            <path d="M18.244 2H21.5l-7.62 8.71L23 22h-7.02l-5.49-6.94L4.2 22H.944l8.15-9.31L1 2h7.2l4.96 6.32L18.244 2Zm-2.46 18.14h1.82L7.28 3.77H5.34l10.444 16.37Z" />
        </svg>
    );
}

export function IconTelegram({ size = 14 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
        >
            <path d="M9.78 16.13 9.42 20a1 1 0 0 0 1.61.79l3.03-2.32 4.66 3.42c.86.48 1.47.23 1.69-.8L22.99 5.5c.31-1.28-.46-1.86-1.29-1.57L3.28 11.29c-1.24.5-1.22 1.2-.22 1.51l4.7 1.47L18.53 7.7c.51-.32.98-.14.6.21L9.78 16.13Z" />
        </svg>
    );
}

export function IconWhatsApp({ size = 14 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
        >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.966-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.762-1.653-2.059-.173-.297-.018-.458.131-.606.134-.133.298-.347.446-.52.15-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.98.999-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.886-9.885 9.886m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413" />
        </svg>
    );
}

export function IconViber({ size = 14 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
        >
            <path d="M11.4 0C9.473.028 5.333.344 3.02 2.467 1.293 4.187.7 6.732.63 9.884c-.062 3.152-.14 9.05 5.542 10.641v2.44s-.038.988.616 1.19c.79.247 1.253-.508 2.008-1.32.414-.446.983-1.106 1.412-1.606 3.88.325 6.855-.42 7.19-.53.789-.257 5.24-.828 5.966-6.744.75-6.098-.359-9.955-2.362-11.696-.599-.556-3.023-2.32-8.45-2.34 0 0-.4-.026-1.152-.02zm.037 1.696c.652-.006 1.05.017 1.05.017 4.588.02 6.583 1.4 7.09 1.865 1.694 1.446 2.558 4.926 1.918 10.019-.6 4.947-4.213 5.26-4.879 5.475-.286.09-2.916.75-6.235.53 0 0-2.475 2.99-3.245 3.762-.117.126-.257.163-.35.14-.128-.033-.163-.187-.163-.407 0-.315.017-3.902.017-3.902-4.797-1.328-4.51-6.353-4.454-8.988.05-2.636.523-4.79 1.987-6.234C7.98 1.968 11.394 1.7 11.437 1.696zm.076 2.34a.294.294 0 0 0-.293.293.294.294 0 0 0 .293.293c1.06 0 1.942.343 2.618.994.336.323.6.717.784 1.174.184.457.28 1.007.28 1.65a.294.294 0 0 0 .294.294.294.294 0 0 0 .293-.294c0-.72-.108-1.35-.322-1.883a3.85 3.85 0 0 0-.933-1.393c-.797-.767-1.83-1.16-3.014-1.16zm-4.75.31A.999.999 0 0 0 6 4.4L5.297 4.586a1.036 1.036 0 0 0-.575.396c-.412.542-1.156 1.9-.79 4.35.316 2.12 1.87 4.53 4.6 6.14 2.647 1.564 4.267 1.86 5.35 1.98.885.096 1.545-.29 1.803-.65.14-.194.336-.475.446-.63.084-.117.078-.291-.014-.4-.32-.379-1.13-.874-1.628-1.13-.365-.187-.75-.226-1.06.033-.322.27-.62.508-.815.505-.31-.008-.895-.257-1.7-.775-.99-.638-1.83-1.55-2.44-2.59-.428-.727-.652-1.29-.66-1.6-.006-.208.226-.532.508-.859.286-.33.328-.727.14-1.086-.263-.502-.756-1.31-1.135-1.63a.363.363 0 0 0-.415-.017zm4.802.868a.294.294 0 0 0-.294.294.294.294 0 0 0 .294.293c.635 0 1.13.194 1.514.586.386.395.585.913.585 1.582a.294.294 0 0 0 .293.293.294.294 0 0 0 .294-.293c0-.816-.256-1.51-.75-2.005-.494-.494-1.18-.75-1.936-.75zm.06 1.11a.294.294 0 0 0-.293.294.294.294 0 0 0 .293.293c.147 0 .213.03.28.098.067.067.098.14.098.294a.294.294 0 0 0 .293.293.294.294 0 0 0 .293-.293c0-.245-.076-.51-.276-.712-.202-.202-.487-.276-.688-.276z" />
        </svg>
    );
}
